import React, { useState, useEffect } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import '../../Slider/Slider.css';
import { SAVINGS, SPENDING } from '../../../../utils';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const AmountRangeSlider = ({ selectedMinAmount, selectedMaxAmount, onAmountChangeProp }) => {
  const currentPath = window.location.pathname;
  const minAmount = 0;
  const maxAmount = 500;
  const [amountRange, setAmountRange] = useState([selectedMinAmount, selectedMaxAmount]);
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const { i18n } = useTranslation();

  const onAmountChange = (values) => {

    if(currentPath === '/' + SPENDING){
      logFirebaseEvents("Spending", "Filter_by_amount", "Filter_by_amount","", "");
  }
else if(currentPath === '/' + SAVINGS){
  logFirebaseEvents("Savings", "Filter_by_amount", "Filter_by_amount","", "");
}

    let [value1, value2] = values;

    // Enforce the constraint: maxAmount should not cross minAmount
    if (value2 < value1) {
      // Swap values to prevent reversing
      [value1, value2] = [value2, value1];
    }

    // Enforce the constraint: maxAmount should not exceed 500
    const constrainedValue2 = Math.min(value2, maxAmount);

    setAmountRange([value1, constrainedValue2]);
    onAmountChangeProp(value1, constrainedValue2);
  };

  useEffect(() => {
    setAmountRange([selectedMinAmount, selectedMaxAmount]);
  }, [selectedMinAmount, selectedMaxAmount]);

  useEffect(() => {
    // Update the text values whenever amountRange changes
    const [amount1, amount2] = amountRange;
    setMinAmountText(`$${amount1}`);
    setMaxAmountText(`$${amount2}`);
  }, [amountRange]);

  const [minAmountText, setMinAmountText] = useState(`$${selectedMinAmount}`);
  const [maxAmountText, setMaxAmountText] = useState(`$${selectedMaxAmount}`);

  const handleReset = () => {
    setAmountRange([minAmount, maxAmount]);
  };

  const handleStyle = {
    borderColor: 'var(--transactions-filter-range-btn',
    backgroundColor: 'var(--transactions-filter-range-btn)',
  };

  const formatAmount = (amount) => {
    // Format currency according to current locale
    const locale = i18n.language || 'en';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  // Calculate left % for Slider handles
  const leftPercentageSlider1 = (amountRange[0] / maxAmount) * 100;
  const leftPercentageSlider2 = (amountRange[1] / maxAmount) * 100;

  return (
    <div className='pl-4 pr-8'>
      <div className="slider-tooltips">
        {/* Custom tooltips for the slider handles */}
        <div className="flex pb-4 relative">
          <div
  className={`font-mono text-[14px] font-normal ${kudzuPlusTrue ? 'slider-tooltip-plus' : 'slider-tooltip-basic' }`}
  style={{
    left: `${(leftPercentageSlider1 + leftPercentageSlider2) / 2}%`,
    width: `calc(${leftPercentageSlider2 - leftPercentageSlider1}% + 50px)`
  }}
>
            <div className="h-full flex items-center sliderTimetext">
              {`${formatAmount(amountRange[0])} - ${formatAmount(amountRange[1])}${amountRange[1] === maxAmount ? '+' : ''}`}
            </div>
            {/* Caret arrows at the edges of the block pointing to slider handles */}
             <div
  className={`sliderCaret ${
    kudzuPlusTrue ? 'sliderCaretPlus' : 'sliderCaretBasic'
  }`}
  style={{ left: 'var(--slider-left-handle-offset)' }}
/>
             <div
  className={`sliderCaret ${
    kudzuPlusTrue ? 'sliderCaretPlus' : 'sliderCaretBasic'
  }`}
  style={{ right: 'var(--slider-right-handle-offset)' }}
/>
          </div>
        </div>
      </div>

      <div className=' flex flex-row gap-0 items-center'>
      <div className=' w-[14px] h-[14px] -mr-1 rounded-full bg-[var(--transactions-filter-range-bg)]' />
      <Slider
        min={minAmount}
        max={maxAmount}
        value={[selectedMinAmount, selectedMaxAmount]}
        onChange={onAmountChange}
        step={1}
        range
        allowCross={false}
        handleStyle={[handleStyle, handleStyle]} // Custom handle styles
        railStyle={{ backgroundColor: 'var(--transactions-filter-range-bg)' }} // Custom rail color
        trackStyle={[{ backgroundColor: 'var(--transactions-filter-tooltip-bg)' }]} // Blue track between handles
        reverse={false}
        keyboard={true}
      />
        <div className=' w-[14px] h-[14px] -ml-1 rounded-full bg-[var(--transactions-filter-range-bg)]' />
      </div>

      <div className="flex pt-4">
        <div className="font-hanken-grotesk text-[var(--TootipText)] block w-[50%] text-[12px] leading-[12px] font-[500] md:text-[12px] md:leading-[12px] sm:text-[11px] sm:leading-[11px] sm:font-medium">
         {formatAmount(minAmount)}
        </div>
        <div className="font-hanken-grotesk text-[var(--TootipText)] block w-[50%] text-[12px] leading-[12px] font-[500] md:text-[12px] md:leading-[12px] sm:text-[11px] sm:leading-[11px] sm:font-medium text-right">
         {formatAmount(maxAmount)}+
        </div>
      </div>
    </div>

  );
};

export default AmountRangeSlider;
